module.exports = __webpack_public_path__ + "static/img/btn.4c99068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn.png
// module id = vsMI
// module chunks = 1